import { t } from "@/i18n-js/instance";

const DELETE_ROOT = "circle_ai_home.delete_chat";
const ACTIONS_ROOT = "circle_ai_home.conversation_actions";

export const conversationActionsCopy = () => ({
  newConversationTitle: t("circle_ai_home.new_conversation"),
  copyLink: {
    menuLabel: t(`${ACTIONS_ROOT}.copy_link.label`),
    successMessage: t(`${ACTIONS_ROOT}.copy_link.toasts.success`),
  },
  delete: {
    menuLabel: t(`${DELETE_ROOT}.actions.delete`),
    modalTitle: t(`${DELETE_ROOT}.confirm.delete.title`),
    confirmText: t(`${DELETE_ROOT}.confirm.delete.confirm`),
    successMessage: t(`${DELETE_ROOT}.toasts.delete_success`),
    errorMessage: t(`${DELETE_ROOT}.toasts.delete_error`),
  },
  rename: {
    menuLabel: t(`${ACTIONS_ROOT}.rename.label`),
    modalTitle: t(`${ACTIONS_ROOT}.rename.modal.title`),
    confirmText: t(`${ACTIONS_ROOT}.rename.modal.confirm`),
    inputLabel: t(`${ACTIONS_ROOT}.rename.input_label`),
    placeholder: t(`${ACTIONS_ROOT}.rename.modal.placeholder`),
    successMessage: t(`${ACTIONS_ROOT}.rename.toasts.success`),
    errorMessage: t(`${ACTIONS_ROOT}.rename.toasts.error`),
  },
  addToProject: {
    menuLabel: t(`${ACTIONS_ROOT}.add_to_project.label`),
    switchMenuLabel: t(`${ACTIONS_ROOT}.add_to_project.switch_label`),
    emptyLabel: t(`${ACTIONS_ROOT}.add_to_project.empty`),
    loadingLabel: t(`${ACTIONS_ROOT}.add_to_project.loading`),
    errorLabel: t(`${ACTIONS_ROOT}.add_to_project.load_error`),
    errorMessage: t(`${ACTIONS_ROOT}.add_to_project.toasts.error`),
    buildSuccessMessage: (project: string) =>
      t(`${ACTIONS_ROOT}.add_to_project.toasts.success`, { project }),
    buildMovedMessage: (project: string) =>
      t(`${ACTIONS_ROOT}.add_to_project.toasts.moved`, { project }),
    removeMenuLabel: t(`${ACTIONS_ROOT}.remove_from_project.label`),
    removeSuccessMessage: t(
      `${ACTIONS_ROOT}.remove_from_project.toasts.success`,
    ),
    removeErrorMessage: t(`${ACTIONS_ROOT}.remove_from_project.toasts.error`),
  },
});

export const conversationDeleteDescription = (title: string) =>
  t(`${DELETE_ROOT}.confirm.delete.description`, { title });
